<template>
  <div>
    <div class="column is-paddingless-bottom is-12 vadDiscussion is-margin-top-small is-paddingless-top"
        v-for="(note, i) in notes" :key="i"
        v-if="notes && notes.length && note">
      <div class="vadDiscussion--bulle is-size-6" v-if="note.comment">
        <div class="content" v-html="note.comment"></div>
      </div>
      <div class="columns is-gapless is-size-6 is-multiline is-vcenteredd">
        <div class="column is-12 is-margin-bottom-xsmall"><!-- is-5-fullhd  -->
          <span v-if="note.created_on">
            <b>Date :</b> {{moment(note.created_on).format('DD MMMM YYYY')}}
          </span>
          <br>
          <span v-if="note.author_name">
            <b>Auteur :</b> {{note.author_name}}
          </span>
        </div>
        <div class="column is-12 is-margin-bottom-xsmall" v-if="hasLeadToggle"> <!-- is-7-fullhd  -->
          <div class="field ">
            <input :id="`to_keep-${i}`" type="checkbox" :name="`to_keep-${i}`"
                    class="switch is-success is-success is-rounded"
                    v-model="note.to_keep" @input="editNote(note)">
            <label :for="`to_keep-${i}`" class="is-size-6 is-padding-top-xxsmall">Récupérer note en commentaire contact</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Notes',
    data () {
      return {
        moment
      }
    },
    props: {
      source: Array,
      params: Object
    },
    computed: {
      notes () {
        return this.source.sort((a, b) => {
          return moment(b.created_on).format('x') - moment(a.created_on).format('x')
        })
      },
      hasLeadToggle () {
        return this.params.leadToggle
      }
    },
    methods: {
      submit () {
        this.$emit('submit', this.notes)
      },
      editNote (note) {
        console.log(note)
        if (this.params.editNote) {
          note.to_keep = !note.to_keep
          this.params.editNote(note)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/Notes.vue